import { render, staticRenderFns } from "./Stories.vue?vue&type=template&id=2062d444&scoped=true"
import script from "./Stories.vue?vue&type=script&lang=js"
export * from "./Stories.vue?vue&type=script&lang=js"
import style0 from "./Stories.vue?vue&type=style&index=0&id=2062d444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2062d444",
  null
  
)

export default component.exports